import { FormControl, Grid, Select, Table, TableBody, TableCell, TableRow
    , TextField, Typography, IconButton, InputLabel, Autocomplete, Box } from '@mui/material'
import { AddCircle as IconAddCircle, Delete as IconDelete } from "@mui/icons-material";
import api from "../services/api";
import moment from 'moment';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { setEntity, setData, add, remove, setTerapeutas, setTiposCargos
    , setValidations, activeValidations
} from '../redux/sessionTherapistSlice'
import DialogYesNo from './DialogYesNo'
import AutocompleteLista from './common/AutocompleteLista';
import { FormHelperText as HelperText } from '@mui/material';

const SessionTherapist = (props) => {
    const isReadOnly = props.isReadOnly;
    const params = useParams();
    const entity = useSelector((state) => state.sessionTherapist.entity)
    const defaultEntity = useSelector((state) => state.sessionTherapist.defaultEntity)
    const listTerapeutas = useSelector((state) => state.sessionTherapist.listTerapeutas)
    const listTiposCargos = useSelector((state) => state.sessionTherapist.listTiposCargos)
    const [openDialogDelete, setOpenDialogDelete] = useState(false)
    const openCloseDialogDelete = () => { setOpenDialogDelete(!openDialogDelete); }
    const [selectNumero, setSelectNumero] = useState(null);
    const [selectId, setSelectId] = useState(null);
    const [numeroDocumentoFocus, setNumeroDocumentoFocus] = useState(null);
    const validate = useSelector((state) => state.sessionTherapist.validationActive);
    const dispatch = useDispatch();

    var validation = {
        AtLeastOneRow: {
            error: entity.length == 1
                &&
                (
                    entity[0].idTerapeuta == 0
                    || entity[0].idTipoCargo == 0
                ),
            message: "Debe haber por lo menos un terapeuta",
        },
    }

    const setItemValue = (numero, name, value) => {
        dispatch(setData({numero: numero, name: name, value: value}))
    }

    const fecthEntity = useCallback(async () => {
        await api.get("/Sesion/GetsSesionTerapeutaView?idSesion=" + params.id)
            .then((response) => {
                console.log(response)
                
                if (response.data.data == null || response.data.data.length == 0){
                    api.get("/Terapia/GetTerapiaPeriodoResumenView?idTerapiaPeriodo=" + params.idTerapiaPeriodo)
                    .then((res) => {
                        console.log(res)
                        
                        if (res.data.data != null){
                            setItemValue(0, "idTerapeuta", res.data.data.idTerapeuta)
                            setItemValue(0, "terapeuta", res.data.data.terapeuta)
                            setItemValue(0, "idTipoCargo", 54)
                            setItemValue(0, "tipoCargo", "Titular")
                        }
                    })
                    .catch((err) => {
                        console.log("Err: ", err);
                    });
                }
                else
                    dispatch(setEntity(response.data.data));
            })
            .catch((err) => {
                console.log("Err: ", err)
            });
    }, [])
    const fetchTerapeutas = useCallback(async () => {
        const response = await api.get("/Persona/GetsListNaturalPersonByTypeAndName?idType=25&name=")
            .catch((err) => {
                console.log("Err: ", err);
            });

        dispatch(setTerapeutas(response.data.data));
    }, [])

    // La carga del autocomplete de terapeutas: con texto busca en el servidor.
    const cargarTerapeutas = useCallback(async (texto) => {
        const response = await api.get(
            `/Persona/GetsListNaturalPersonByTypeAndName?idType=25&name=${encodeURIComponent(texto || "")}`)
            .catch((err) => {
                console.log("Err: ", err);
                return { data: { data: [] } };
            });

        return (response?.data?.data || []).map((row) => ({ id: row.id, descripcion: row.descripcion }));
    }, [])
    const fetchTiposCargos = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=53")
            .catch((err) => {
                console.log("Err: ", err);
            });
        dispatch(setTiposCargos(response.data.data));
    }, [])

    useEffect(() => {
        fecthEntity();
        fetchTerapeutas();
        fetchTiposCargos();
    }, [])

    useEffect(() => {
        dispatch(setValidations(messagesValidation()));
    }, [entity])

    useEffect(() => {
        
    }, [entity])

    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    const deleteEntity = async () => {
        await api.delete("/Sesion/DeleteSesionTerapeuta?idSesion="
                + params.id + "&numero=" + selectNumero)
            .catch((err) => {
                console.log("Err: ", err);
            });
        dispatch(remove(selectNumero));
    }
 
    return (
        <Grid container>
            <Grid item>
                <Typography variant="h7">
                    <Box sx={{ fontWeight: 'bold' }} padding={0}>
                        {"Terapeutas (" + (entity != null ? entity.length : 0) + ")"}
                    </Box>
                </Typography>
            </Grid>
            <Grid item>
                <IconButton disabled={isReadOnly} size="small" aria-label="Agregar Terapeuta" style={{height: 10}} onClick={() => {
                    dispatch(add(params.id));
                }}>
                    <IconAddCircle />
                </IconButton>
            </Grid>
            <Grid container>
                {/* {JSON.stringify(entity)} */}
                {/* {JSON.stringify(numeroDocumentoExistente)} */}
                <Table size="small">
                    <TableBody>
                        {entity.map((row, index) => (
                            <TableRow key={row.numero} sx={(theme) => ({
                                backgroundColor: index % 2 === 1 ? theme.palette.action.selected : 'inherit',
                                "&:last-child td, &:last-child th": { borderRadius: "0.5em" },
                            })}>
                                <TableCell sx={{ px: 0.5, py: 1 }}>
                                    <Grid container spacing={1} padding={0} sx={{ alignItems: "center", maxWidth: { lg: 720 } }}>
                                        <Grid item xs={12} sm={6} md={6} lg={5}>
                                            <FormControl required fullWidth error={validate.terapeuta && validation.terapeuta.error}>
                                                {/* La lista de terapeutas crece con cada terapeuta que se
                                                    registra, asi que el desplegable es un autocomplete: al
                                                    abrirlo estan los primeros 50 (en orden alfabetico) y al
                                                    escribir se busca en el servidor. */}
                                                <AutocompleteLista
                                                    label="Terapeuta"
                                                    name="idTerapeuta"
                                                    value={row.idTerapeuta || 0}
                                                    texto={row.terapeuta || ""}
                                                    cargar={cargarTerapeutas}
                                                    disabled={isReadOnly}
                                                    onChange={(id, texto) => {
                                                        setItemValue(row.numero, "idTerapeuta", id)
                                                        setItemValue(row.numero, "terapeuta", texto)
                                                    }}
                                                    size="small"
                                                />
                                                <HelperText>{validate.terapeuta && validation.terapeuta.error ? validation.terapeuta.message : ""}</HelperText>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={8} sm={5} md={4} lg={3}>
                                            <FormControl required fullWidth>
                                                <InputLabel htmlFor="input-tipocargo">Tipo Cargo</InputLabel>
                                                <Select
                                                    //native={!diasSemana.length == 0}
                                                    native
                                                    //defaultValue={0}
                                                    label="Tipo Cargo"
                                                    value={row.idTipoCargo}
                                                    fullWidth
                                                    onChange={(event, newValue) => {
                                                        var id = event.nativeEvent.target.selectedIndex;

                                                        setItemValue(row.numero, "idTipoCargo", event.target.value)
                                                        setItemValue(row.numero, "tipoCargo", event.nativeEvent.target[id].text)
                                                    }}
                                                    inputProps={{
                                                        name: 'idTipoCargo',
                                                        id: 'input-tipocargo',
                                                    }}
                                                    disabled={isReadOnly}
                                                    size="small"
                                                >
                                                    <option key={0} value={0}>{"(Seleccione)"}</option>
                                                    {listTiposCargos.map((row) => (
                                                        <option key={row.id} value={row.id}>{row.descripcion}</option>
                                                    ))}
                                                </Select>
                                                {/* <HelperText>
                                                    {validate.DNIWith8Digits && validation.DNIWith8Digits.error ? validation.DNIWith8Digits.message : ""}
                                                </HelperText>
                                                <HelperText>
                                                    {validate.AnyDocumentAtLeast3Digits && validation.AnyDocumentAtLeast3Digits.error ? validation.AnyDocumentAtLeast3Digits.message : ""}
                                                </HelperText> */}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4} sm={1} sx={{ display: "flex", alignItems: "center" }}>
                                            <IconButton aria-label="delete" disabled={isReadOnly} onClick={() => {
                                                if (row.id > 0) {
                                                    setSelectId(row.id);
                                                    setSelectNumero(row.numero);
                                                    setOpenDialogDelete(true);
                                                }
                                                else {
                                                    dispatch(remove(row.numero));
                                                }

                                            }}>
                                                <IconDelete />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <FormControl required fullWidth
                    error={
                        (validate.AtLeastOneRow && validation.AtLeastOneRow.error)
                    }>

                    <HelperText>
                        {validate.AtLeastOneRow && validation.AtLeastOneRow.error ? validation.AtLeastOneRow.message : ""}
                    </HelperText>
                </FormControl>
            </Grid>
            <DialogYesNo
                open={openDialogDelete}
                openClose={openCloseDialogDelete}
                setYes={deleteEntity}
                setNo={() => { return }}
                titulo={"Borrar terapeuta"}
                texto={"Esta seguro de borrar el terapeuta?"}
            ></DialogYesNo>
        </Grid>
    )
}

export default SessionTherapist;